const CUSTOM_LAT_LNG_CONSTRUCTOR_NAME = 'latLngTemplate';

export {
    CUSTOM_LAT_LNG_CONSTRUCTOR_NAME
};
